<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">Compliance Flags</h4>
        <div class="text-muted small">Review and resolve open compliance issues</div>
      </div>

      <div>
        <a routerLink="/admin/country-change-requests" class="btn btn-outline-secondary btn-sm">
          Back to Country Changes
        </a>
      </div>
    </div>

    <div class="card border-0 shadow-sm">
      <div class="card-body p-0">
        <div *ngIf="loading" class="p-4 text-center text-muted">
          Loading...
        </div>

        <div *ngIf="!loading" class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="table-light">
              <tr class="small text-muted">
                <th>User</th>
                <th>Reason</th>
                <th>Risk</th>
                <th>Status</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let flag of flags">
                <td>
                  <div class="fw-semibold">{{ flag.fullName || flag.userId }}</div>
                  <div class="small text-muted">{{ flag.email }}</div>
                </td>

                <td>{{ flag.reason }}</td>

                <td>
                  <span class="badge" [ngClass]="getRiskBadgeClass(flag.riskLevel)">
                    {{ flag.riskLevel }}
                  </span>
                </td>

                <td>{{ flag.status }}</td>
                <td>{{ flag.createdAt | date:'short' }}</td>

                <td class="text-end">
                  <button class="btn btn-outline-primary btn-sm" (click)="resolve(flag)">
                    Resolve
                  </button>
                </td>
              </tr>

              <tr *ngIf="flags.length === 0">
                <td colspan="6" class="text-center text-muted p-3">
                  No open compliance flags
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</div>